module.exports = __webpack_public_path__ + "img/jala.ee94b092.svg";